import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77862bc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "focus-controller-container" }

import { MapSettingsInterface } from "@/types/map/interfaces";
import { IonButton, IonIcon } from "@ionic/vue";
import { homeOutline } from "ionicons/icons";
import { Map } from "maplibre-gl";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FocusController',
  props: {
  map: {
    type: Map,
    required: true,
  },
  settings: {
    type: Object as PropType<MapSettingsInterface>,
    required: false
  }
},
  setup(__props) {

const props = __props;



function focusGeoObject() {
  props.map.flyTo({
    center: props.settings?.mapCenter || [16.363449, 48.210033],
    zoom: props.settings?.mapInitialZoomLevel,
    minZoom: props.settings?.minZoom || 0,
    speed: 0.5,
    essential: true,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonButton), {
      class: "focus-button",
      size: "small",
      color: "light",
      onClick: focusGeoObject
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonIcon), {
          slot: "icon-only",
          icon: _unref(homeOutline)
        }, null, 8, ["icon"])
      ]),
      _: 1
    })
  ]))
}
}

})